import {
  FIELD_ORDER_UI_SCHEMA_KEY,
  SECTION_NAME_UI_SCHEMA_KEY,
  ShapeUISchemaNestedShapeValues,
  SHOW_DIVIDER_LINE_KEY,
  StepConfigEditorOverride,
} from '../../StepConfigEditorTypes';
import {createDiscreteColorPaletteSection, createLegendStyleSection} from './ChartSchemaHelpers';

/**
 * Pie Chart configuration sections for the Configure tab
 */
export const PIE_CHART_CONFIG_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['nameSection', 'sliceSection', 'measureSection', 'colorPaletteSection'],
  nameSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['chartName'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    chartName: {
      displayName: 'Title',
      configShapePath: ['chartName'],
    },
  },
  sliceSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['sliceColumnName'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    sliceColumnName: {
      displayName: 'Slice',
      configShapePath: ['chartConfig', 'parameters', 'sliceColumnName'],
    },
  },
  measureSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['measureColumnName'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    measureColumnName: {
      displayName: 'Measure',
      configShapePath: ['chartConfig', 'parameters', 'measureColumnName'],
    },
  },
  colorPaletteSection: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['colorSection'],
    [SHOW_DIVIDER_LINE_KEY]: true,
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Color Palette',
    colorSection: createDiscreteColorPaletteSection(['chartConfig', 'parameters', 'sliceColumnName']),
  },
} as const satisfies ShapeUISchemaNestedShapeValues;

/**
 * Pie Chart style sections for the Style tab
 */
export const PIE_CHART_STYLE_SECTIONS = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['legendSection', 'sliceLabelSection'],
  legendSection: createLegendStyleSection({infoText: false, disableFn: false}),
  sliceLabelSection: {
    [SECTION_NAME_UI_SCHEMA_KEY]: 'Slice labels',
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['showSliceNameInLabel', 'showPercentageInLabel', 'showValueInLabel'],
    showSliceNameInLabel: {
      configShapePath: ['chartConfig', 'parameters', 'showSliceNameInLabel'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Show slice name',
      },
    },
    showPercentageInLabel: {
      configShapePath: ['chartConfig', 'parameters', 'showPercentageInLabel'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Show percentage',
      },
    },
    showValueInLabel: {
      configShapePath: ['chartConfig', 'parameters', 'showValueInLabel'],
      editorOverride: StepConfigEditorOverride.CHECKBOX,
      fieldSettings: {
        checkboxLabel: 'Show value',
      },
    },
  },
} as const satisfies ShapeUISchemaNestedShapeValues;
